import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { timezoneStringLabel } from '../../../dateUtils';
import timezones from './ReactTimezoneSelectTzList';
import './TimezoneSelector.scss';

const createTzOptionObject = (tzStr) => {
  if (!tzStr) {
    return null;
  }
  const label = timezoneStringLabel(tzStr);

  return { value: tzStr, label };
};

function TimezoneSelector({
  selectedValue,
  onChange,
  disabled = false,
}) {
  const handleChange = (timezone) => {
    if (onChange) { onChange(timezone); }
  };

  const selectOptions = React.useMemo(() => {
    const americanTimeKeys = ['America/Los_Angeles', 'America/Denver', 'America/Chicago', 'America/New_York'];
    const otherTimezoneStrings = Object.keys(timezones).filter(
      (timezone) => !americanTimeKeys.includes(timezone),
    ).map((tzStr) => createTzOptionObject(tzStr)).sort(
      (a, b) => {
        const offsetA = parseFloat(a.label.slice(a.label.indexOf('(') + 4, a.label.indexOf(')')));
        const offsetB = parseFloat(b.label.slice(b.label.indexOf('(') + 4, b.label.indexOf(')')));
        return offsetA - offsetB;
      },
    );
    const timezoneStrings = [...americanTimeKeys.map((tzStr) => createTzOptionObject(tzStr)),
      createTzOptionObject('seperator'), ...otherTimezoneStrings];
    return timezoneStrings;
  }, []);

  const formatOptionLabel = ({ label }, { context }) => {
    if (context === 'menu') {
      if (label === 'seperator') {
        return (
          <div>
            <hr style={{ margin: '8px 0' }} />
          </div>
        );
      }
    }
    return <div>{label}</div>;
  };

  return (
    <div className="timezone-selector-component-container">
      <Select
        value={createTzOptionObject(selectedValue)}
        options={selectOptions}
        closeMenuOnSelect
        classNamePrefix="timezone-select"
        placeholder="-Select one-"
        onChange={(newTimezone) => handleChange(newTimezone.value)}
        isDisabled={disabled}
        formatOptionLabel={formatOptionLabel}
      />
    </div>
  );
}

TimezoneSelector.propTypes = {
  selectedValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

TimezoneSelector.defaultProps = {
  selectedValue: null,
  disabled: false,
};

export default TimezoneSelector;
